<template>
  <div class="ranking">
    <div class="ranking-container">
      <ui-box>
        <template v-slot:nav-left>
          <ui-tag
            v-for="(tab, index) in activeTitle"
            :key="index"
            :id="tab.type"
            :active="records === index"
            :class="['tab', tab.type]"
            :data-id="`id-${index}`"
            @click.native="honorToggle(index)"
          >
            <div v-show="!isInterdict && tab.type === 'popularity'" class="tanc" @click="handleClickshowRank"></div>
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
            </div>
          </ui-tag>
        </template>
        <template v-slot:nav-right>

        </template>
        <template v-slot:container>
          <RankingRegister
            :dataList="listData"
            :personaList="personaList"
            :records="records"
            :activeIndex="activeIndex"      
          >
          </RankingRegister>
        </template>
      </ui-box>
    </div>

    <rnkingRewards ref="rnkingRewards"></rnkingRewards>
    <personalRewardsPop ref="popup"></personalRewardsPop>
    <personalRewardsRenqi ref="renqi"></personalRewardsRenqi>
    <GivePresent ref="present"></GivePresent>
   
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import RankingRegister from './ranking-register'
import rnkingRewards from './rnking-rewards.vue'
import personalRewardsPop from '@/views/ranking/personal-rewards-pop'
import personalRewardsRenqi from '@/views/ranking/personal-rewards-renq'
import GivePresent from '@/views/live/givePresent.vue'
import * as api from '@/service/index'

export default {
  components: {
    RankingRegister,
    rnkingRewards,
    personalRewardsPop,
    personalRewardsRenqi,
    UiBox,
    UiTag,
    GivePresent
  },
  provide() {
    return {
      getTeamRankingsList: this.getTeamRankingsList,
      honorToggle: this.honorToggle,
      handleClickshowRank: this.handleClickshowRank,
      handleCkickshowPop:this.handleCkickshowPop,
      handleCkickshowRenqi: this.handleCkickshowRenqi
    }
  },
  data() {
    return {
      activeTitle: [
        { name: '人气排行榜', type: 'popularity' },
        { name: '个人排行榜', type: 'personal' },
        { name: '战队', type: 'team' },
      ],
      // activeType: ['season', 'week', 'preWeek'],
      selected: 0,
      activeBar: ['战队排行榜', '个人排行榜'],
      records: 0,
      // 战队排行
      listData: {
        clanRank: [],
        personalGifts:{},
        personal:[]
      },
      inRequest: false,

      personaList: {
        totalList: [],
        personal:{}
      },
      type: 'season',
      activeIndex: 0,
      userInfo: {},
    }
  },
  created() {
    // TODO 二阶段开放
    this.livePersonalRanking()
    let routeParams = this.$route.params;

    // 不显示送礼模块时，默认显示战队列表
    let defaultRecords = this.isInterdict ? 2 : 0;
    this.records = routeParams?.records || defaultRecords;
  },
  computed: {
    ...mapState(['token', 'teamsInfo', 'isInterdict', 'popupStatus']),
    selectedData() {
      if (this.records !== null) {
        if (this.records === 0) {
          return this.listData
        } 
        if(this.records === 1){
          return this.personaList 
        }
      }
      return null
    }
  },
  watch: {
    'popupStatus': {
      handler(newVal, oldVal) {
        if(newVal && newVal != oldVal){
          if(newVal.id == 'present'){
            let team = newVal.params?.team;
            let presentList = newVal.params?.presentList;
            this.$refs.present.openPresent(team, presentList)
          }
        }
      }
    }
  },
  methods: {
    honorToggle(index) {
      if (this.records != index) {
         this.records = index
        switch (this.records) {
          case 0:
            // 不显示送礼模块时，拦截不必要的请求
            if(!this.isInterdict) { 
              this.livePersonalRanking()
            }
            break
          case 1:
            // 不显示送礼模块时，拦截不必要的请求
            if(!this.isInterdict) {
              this.getPersonalRankingsList()
            }
            break
          case 2:
            break
          default: ""
        }
      } 
    },
    handleClickshowRank(){
      this.$refs.rnkingRewards.getAmount()
    },
    handleCkickshowPop(){
      this.$refs.renqi.getAmount()
    },
    handleCkickshowRenqi(){
      this.$refs.popup.getAmount()
    },
    async getGiftTeamDetailFn(teamCode){
      let res = {
        token: this.token,
        teamCode: teamCode,
        rankType:this.type
      }
      try {
        let {data} = await api.getGiftTeamDetail(res)
        this.listData.personalGifts = data.personal
        this.listData.personal = data.totalList

        const personal_length = this.listData.personal.length;
        if(personal_length < 3) {
          for(let i = 0; i < 3 - personal_length; i++) {
            this.listData.personal.push({
              avatarUrl: '',
              nickName: '-',
              popularity: 0,
              time: 0
            })
          }
        }
      }catch (err) {
        console.log(err)
      }
     
    },
    async livePersonalRanking() {
      if(!this.token) return;
      try {
        this.activeIndex = 0
        let { status, data } = await api.getGiftTeamList(this.token)
        if (status === 200) {
          // 排行数据
          this.listData.clanRank = data
          // 获取详情数据
          this.getGiftTeamDetailFn(this.listData.clanRank[0].teamCode)
        }else{
          // console.log(123)
          alert(data)
        }
      } catch (err) {
        // console.log(err)
        console.log(err)
      }
    },


    async getPersonalRankingsList() {
      if(!this.token) return;
      try {
        const {data} = await api.getPersonalRanking(this.token)
        // console.log(data)
        this.personaList.totalList = data.totalList
        this.personaList.personal = data.personal
      } catch (err) {
        console.log(err)
      }
    },
    

    async fetchuserPersonaldata(data) {
      const res = await api.userPersonalRankValue(data)
      if (res.status === 200) {
        return res.data
      }
      return null
    },


    // 获取战队 个人排行榜
    async getTeamRankingsList(index) {
      this.activeIndex = index ? index : 0
      let count = this.listData.clanRank[index].teamCode
      this.getGiftTeamDetailFn(count)
    },

  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/ranking/index';
</style>
